import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

interface IVisibilityOnProps extends IIconProps {
  width?: number;
  height?: number;
}

const VisibilityOn: React.FC<IVisibilityOnProps> = ({
  size = IconSizes.lg,
  width,
  height,
  color = '#000',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={width || IconWidth[size]}
      height={height || IconHeight[size]}
      color={color}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M12.0008 15.575C13.1341 15.575 14.0964 15.179 14.8878 14.387C15.6798 13.5957 16.0758 12.6333 16.0758 11.5C16.0758 10.3667 15.6798 9.40433 14.8878 8.613C14.0964 7.821 13.1341 7.425 12.0008 7.425C10.8674 7.425 9.90511 7.821 9.11378 8.613C8.32178 9.40433 7.92578 10.3667 7.92578 11.5C7.92578 12.6333 8.32178 13.5957 9.11378 14.387C9.90511 15.179 10.8674 15.575 12.0008 15.575ZM12.0008 14.2C11.2508 14.2 10.6134 13.9373 10.0888 13.412C9.56345 12.8873 9.30078 12.25 9.30078 11.5C9.30078 10.75 9.56345 10.1123 10.0888 9.587C10.6134 9.06233 11.2508 8.8 12.0008 8.8C12.7508 8.8 13.3884 9.06233 13.9138 9.587C14.4384 10.1123 14.7008 10.75 14.7008 11.5C14.7008 12.25 14.4384 12.8873 13.9138 13.412C13.3884 13.9373 12.7508 14.2 12.0008 14.2ZM12.0008 18.5C9.70078 18.5 7.60511 17.8667 5.71378 16.6C3.82178 15.3333 2.43411 13.6333 1.55078 11.5C2.43411 9.36667 3.82178 7.66667 5.71378 6.4C7.60511 5.13333 9.70078 4.5 12.0008 4.5C14.3008 4.5 16.3968 5.13333 18.2888 6.4C20.1801 7.66667 21.5674 9.36667 22.4508 11.5C21.5674 13.6333 20.1801 15.3333 18.2888 16.6C16.3968 17.8667 14.3008 18.5 12.0008 18.5ZM12.0008 17C13.8841 17 15.6134 16.504 17.1888 15.512C18.7634 14.5207 19.9674 13.1833 20.8008 11.5C19.9674 9.81667 18.7634 8.479 17.1888 7.487C15.6134 6.49567 13.8841 6 12.0008 6C10.1174 6 8.38811 6.49567 6.81278 7.487C5.23811 8.479 4.03411 9.81667 3.20078 11.5C4.03411 13.1833 5.23811 14.5207 6.81278 15.512C8.38811 16.504 10.1174 17 12.0008 17Z"
        fill={color}
      />
    </svg>
  );
};

export default VisibilityOn;
